<template>
	<v-container fluid>
		<v-subheader class="pa-0"><strong>ID: {{ id_nuevo_grupo }}</strong> </v-subheader>
	  <v-row>
    	<v-col cols="12">
        <v-text-field
          v-model="nombreGrupo"
          label="* Grupo"
          filled
          hide-details
          dense
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-select
        	:items="planteles"
          v-model="siguienteGrupo.id_plantel"
          label="Plantel"
          outlined
          hide-details
          dense
          item-text="plantel"
          item-value="id_plantel"
          readonly
        ></v-select>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="cursos"
          v-model="siguienteGrupo.id_curso"
          label="Curso"
          outlined
          hide-details
          dense
          item-text="curso"
          item-value="id_curso"
          :readonly="editar"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="ciclos"
          v-model="siguienteGrupo.id_ciclo"
          label="Ciclo"
          outlined
          hide-details
          dense
          item-text="ciclo"
          item-value="id_ciclo"
          readonly
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="horarios"
          v-model="siguienteGrupo.id_horario"
          label="Horario"
          outlined
          hide-details
          dense
          item-text="horario"
          item-value="id_horario"
          :readonly="editar"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="filterSalones"
          v-model="siguienteGrupo.id_salon"
          label="Salon"
          outlined
          hide-details
          dense
          item-text="salon_label"
          item-value="id_salon"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-select
        	:items="niveles"
          v-model="siguienteGrupo.id_nivel"
          label="Nivel"
          outlined
          hide-details
          dense
          item-text="nivel"
          item-value="id_nivel"
          readonly
        ></v-select>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="siguienteGrupo.cupo"
          label="Cupo"
          filled
          hide-details
          dense
          :readonly="editar"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="siguienteGrupo.precio"
          label="* precio"
          filled
          hide-details
          dense
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" class="pt-0">
      	<v-switch 
      		label="¿Activo Si/No?"
          hide-details
      		v-model="siguienteGrupo.activo_sn"
      		:readonly="editar"
      	>
      	</v-switch>
      </v-col>

      <v-col cols="12" sm="6" class="pt-0">
      	<div class="text-subtitle-1"><b>Fecha alta:</b> {{ siguienteGrupo.fecha_alta }}</div>
      	<div class="text-subtitle-1"><b>Fecha baja:</b> {{ siguienteGrupo.fecha_baja }}</div>
      </v-col>

      <v-col cols="12" align="right">
        <v-btn color="primary" @click="save" :disabled="!siguienteGrupo.id_salon">
          {{ editar ? 'Guardar salón' : 'Guardar' }}
        </v-btn>
      </v-col>
    </v-row>

	  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
  import salonesDisponibles from '@/mixins/salonesDisponibles'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  export default {

  	mixins: [ salonesDisponibles ],

  	components:{
      Alerta,
      carga,
    },

  	props:[
			'editedItem',
			'gruposOcupacion',
			'horariosCatalog'
	  ],
    data: () => ({

    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      ciclos:[],
			salones:[],
			cursos:[],
			planteles:[],
			horarios:[],
			niveles:[],

			editar: false,

			siguienteGrupo: {},
			id_nuevo_grupo: 0
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),

    	nombreGrupo( ){
    		const existe = this.planteles.find( el=> el.id_plantel == this.siguienteGrupo.id_plantel )
    		const plantel = existe ? existe.plantel.trim() : ''

				const existe2 = this.ciclos.find( el=> el.id_ciclo == this.siguienteGrupo.id_ciclo )
				const ciclo = existe2 ? existe2.ciclo.trim() : ''

				const existe3 = this.horarios.find( el=> el.id_horario == this.siguienteGrupo.id_horario )
				const horario = existe3 ? existe3.horario.trim() : ''

				const existe4 = this.niveles.find( el=> el.id_nivel == this.siguienteGrupo.id_nivel )
				const nivel = existe4 ? existe4.nivel.trim() : ''

				const existe5 = this.cursos.find( el=> el.id_curso == this.siguienteGrupo.id_curso )
				if (existe5) {
					this.siguienteGrupo.precio = existe5.precio_nivel
				}

    		return `${plantel} - ${ciclo} - ${horario} - ${nivel}`
    	},

      filterSalones () {
        const catalog = this.horariosCatalog || this.horarios || []
        const h = catalog.find(x => x.id_horario == this.siguienteGrupo.id_horario)
        const grupoRef = h
          ? {
            ...this.siguienteGrupo,
            hora_inicio: this.siguienteGrupo.hora_inicio || h.hora_inicio,
            hora_fin: this.siguienteGrupo.hora_fin || h.hora_fin
          }
          : this.siguienteGrupo

        return this.filterSalonesDisponibles({
          salones: this.salones,
          idPlantel: this.siguienteGrupo.id_plantel,
          idCiclo: this.siguienteGrupo.id_ciclo,
          idHorario: this.siguienteGrupo.id_horario,
          idSalonActual: this.siguienteGrupo.id_salon,
          grupos: this.gruposOcupacion || [],
          excludeGrupoId: this.id_nuevo_grupo,
          horariosCatalog: catalog,
          grupoRef
        })
      }
    },

    async created () {
    	this.id_nuevo_grupo = this.editedItem.id_grupo_consecutivo || 0
    	this.editar = this.id_nuevo_grupo > 0

      await Promise.all([
        this.getCiclos(),
        this.getSalones(),
        this.getCursos(),
        this.getPlanteles(),
        this.getHorarios(),
        this.getNiveles(),
      ])

      if (this.editar) {
        await this.cargarGrupoSiguiente()
      } else {
        this.prepararNuevoSiguiente()
      }
    },

    methods: {

      prepararNuevoSiguiente () {
        this.siguienteGrupo = Object.assign({}, this.editedItem)
        this.siguienteGrupo.activo_sn = 1

        const nivelActual = this.niveles.find(el => el.id_nivel == this.editedItem.id_nivel)
        if (nivelActual && nivelActual.id_nivel_consecutivo > 0) {
          this.siguienteGrupo.id_nivel = nivelActual.id_nivel_consecutivo
        }

        const existeCiclo = this.ciclos.find(el => el.id_ciclo == this.editedItem.id_ciclo)
        if (existeCiclo) {
          const nombreCiclo = existeCiclo.ciclo.split(' ')
          const numeroCiclo = nombreCiclo[1].split('_')
          const mesCiclo = parseInt(numeroCiclo[0]) == 12 ? 1 : (parseInt(numeroCiclo[0]) + 1)
          const anioCiclo = parseInt(numeroCiclo[0]) == 12 ? (parseInt(numeroCiclo[1]) + 1) : parseInt(numeroCiclo[1])
          const sufijoFe = String(existeCiclo.ciclo).includes('FE') ? ' FE' : ''
          const nuevoCiclo = 'CICLO ' + (mesCiclo < 10 ? ('0' + mesCiclo) : mesCiclo) + '_' + anioCiclo + sufijoFe
          const existeNuevoCiclo = this.ciclos.find(el => el.ciclo == nuevoCiclo)
          if (existeNuevoCiclo) {
            this.siguienteGrupo.id_ciclo = existeNuevoCiclo.id_ciclo
          }
        }
      },

      async cargarGrupoSiguiente () {
        try {
          const response = await this.$http.get('grupos.detalle/' + this.id_nuevo_grupo)
          this.siguienteGrupo = Object.assign({}, response.data)
          this.siguienteGrupo.activo_sn = this.siguienteGrupo.activo_sn == 1
        } catch (error) {
          this.validarError(error.response && error.response.data ? error.response.data.message : error.message)
          this.prepararNuevoSiguiente()
          this.editar = false
          this.id_nuevo_grupo = 0
        }
      },

    	save () {
      	this.siguienteGrupo['id_usuario'] = this.getdatosUsuarioERPERP.iderp
      	this.siguienteGrupo['grupo'] = this.nombreGrupo

      	if (this.editar) {
      		this.cargar = true
      		this.$http.put('grupos.update/' + this.id_nuevo_grupo, this.siguienteGrupo).then(response => {
      			this.validarSuccess(response.data.message)
      			this.$emit('click')
      		}).catch(error => {
      			this.validarError(error.response && error.response.data ? error.response.data.message : error.message)
      		}).finally(() => { this.cargar = false })
      		return
      	}

      	this.siguienteGrupo['disponibles'] = this.siguienteGrupo.cupo || 20
      	this.siguienteGrupo['id_grupo_original'] = this.editedItem.id_grupo
	      this.cargar = true
        this.$http.post('grupos.add', this.siguienteGrupo).then(response=>{
        	this.id_nuevo_grupo = response.data.id
        	this.editar = true
        	this.validarSuccess( response.data.message )
        	this.$emit('click')
        	this.cargarGrupoSiguiente()
        }).catch( error =>{
        	this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        }).finally( () => { this.cargar = false })
      },

      getCiclos () {
      	this.cargar = true
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
        	this.ciclos = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        }).finally( () => { this.cargar = false })
      },

      getSalones () {
      	this.cargar = true
        this.salones = []
        return this.$http.get('salones.activos').then(response=>{
        	this.salones = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        }).finally( () => { this.cargar = false })
      },

      getCursos () {
      	this.cargar = true
        this.cursos = []
        return this.$http.get('cursoserp.activos').then(response=>{
        	this.cursos = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
        	this.planteles = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        }).finally( () => { this.cargar = false })
      },

      getHorarios () {
      	this.cargar = true
        this.horarios = []
        return this.$http.get('horarios.activos').then(response=>{
        	this.horarios = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        }).finally( () => { this.cargar = false })
      },

      getNiveles () {
      	this.cargar = true
        this.niveles = []
        return this.$http.get('niveles.activos').then(response=>{
        	this.niveles = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        }).finally( () => { this.cargar = false })
      },

      validarSuccess( mensaje ){
        this.cargar = false
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = 'success'
        this.respuestaAlerta         = true 
      },

      validarError ( value ) {
        this.cargar = false 
        const mensaje = typeof value === 'string'
          ? value
          : (value && value.body && value.body.message) || (value && value.message) || 'Error'
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = '#FF2C2C'
        this.respuestaAlerta = true 
      },
    },
  }
</script>
